import { ModifyStateFunction } from './types';
export function getViewActions(setState: ModifyStateFunction) {
  return {
    openContent: () => {
      setState((current) => ({ ...current, view: { ...current.view, contentIsOpen: true } }));
    },
    closeContent: () => {
      setState((current) => ({ ...current, view: { ...current.view, contentIsOpen: false } }));
    },
    enterEditMode: () => {
      setState((current) => ({ ...current, view: { ...current.view, inEditMode: true } }));
    },
    leaveEditMode: () => {
      setState((current) => ({ ...current, view: { ...current.view, inEditMode: false } }));
    },
  };
}
